var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComparatorArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 64,
    width: 64,
    height: 64,
    transform: "rotate(-90 0 64)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 32.0002L45.3333 42.6668L41.6 38.9335L45.8 34.6668L34.6667 34.6668C33.2 34.6668 31.9444 35.189 30.9 36.2335C29.8556 37.2779 29.3333 38.5335 29.3333 40.0002L29.3333 56.0002C29.3333 57.4668 28.8111 58.7224 27.7667 59.7668C26.7222 60.8113 25.4667 61.3335 24 61.3335L8 61.3335L8 56.0002L24 56.0002L24 40.0002C24 38.4002 24.3222 36.9113 24.9667 35.5335C25.6111 34.1557 26.4889 32.9779 27.6 32.0002C26.4889 31.0224 25.6111 29.8446 24.9667 28.4668C24.3222 27.089 24 25.6002 24 24.0002L24 8.00016L8 8.00016L8 2.66683L24 2.66683C25.4667 2.66683 26.7222 3.18905 27.7667 4.23349C28.8111 5.27794 29.3333 6.53349 29.3333 8.00016L29.3333 24.0002C29.3333 25.4668 29.8556 26.7224 30.9 27.7668C31.9444 28.8113 33.2 29.3335 34.6667 29.3335L45.8 29.3335L41.6 25.1335L45.3333 21.3335L56 32.0002Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparatorArrow);
export default __webpack_public_path__ + "static/media/comparator-arrow.894837146669ae701026d69be707fa9a.svg";
export { ForwardRef as ReactComponent };